import { render, staticRenderFns } from "./RegisteredProductsClosedWarranty.vue?vue&type=template&id=3429a4cb"
import script from "./RegisteredProductsClosedWarranty.vue?vue&type=script&lang=js"
export * from "./RegisteredProductsClosedWarranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports